import {Label, Segment} from 'platform/components';
import {VStack} from 'platform/foundation';

import {LeasingTargetGroup} from '@dms/api/vehicle';

import {getLeasingTargetGroupLabel} from '../utils/getLeasingTargetGroupLabel';

interface LeasingTargetGroupFieldProps<TTargetGroup extends LeasingTargetGroup> {
  label: string;
  tooltip: string;
  value: TTargetGroup;
  options: TTargetGroup[];
  isDisabled: boolean;
  onChange: (targetGroup: TTargetGroup) => void;
}

export function LeasingTargetGroupField<TTargetGroup extends LeasingTargetGroup>(
  props: LeasingTargetGroupFieldProps<TTargetGroup>
) {
  const segmentOptions = props.options.map((targetGroup) => ({
    value: targetGroup,
    label: getLeasingTargetGroupLabel(targetGroup),
  }));

  return (
    <VStack spacing={0}>
      <Label tooltip={props.tooltip}>{props.label}</Label>
      <Segment<TTargetGroup>
        label={props.label}
        value={props.value}
        isDisabled={props.isDisabled}
        options={segmentOptions}
        onChange={props.onChange}
      />
    </VStack>
  );
}
